import React from "react";
import Paragraph from "../../../Paragraph";

// TODO: There is some weird spacing issues before going into tablet responsive view.
// It think we need to set relative width's on both absolute containers to fix it.
interface PlatformFeaturProps {
  features?: any;
}
const PlatformFeatureBar: React.FC<PlatformFeaturProps> = props => {
  const { features } = props;
  return (
    <div className="relative flex justify-center w-full h-200 mt-18 lg:h-37 lg:mt-20">
      <div className="absolute grid grid-cols-1 grid-flow-row gap-36 top-40 lg:grid-rows-1 lg:grid-flow-col lg:gap-22 lg:top-9 lg:auto-cols-fr">
        <Dash />
        <Dash />
        <Dash />
      </div>
      <div className="absolute grid grid-cols-1 auto-cols-min grid-flow-row gap-22 lg:grid-rows-1 lg:grid-flow-col lg:gap-6 lg:auto-cols-fr">
        {features &&
          features?.map(feature => {
            return (
              <div
                key={feature.id}
                className="flex flex-col items-center"
                style={{ width: "240px", minWidth: "240px" }}
              >
                <span className="rounded-full inline-block bg-white shadow-xl p-5 h-16 w-16">
                  <img width="24" height="24" src={feature?.svg?.url} alt={feature?.text} />
                </span>
                <Paragraph className="mt-7 font-semibold">
                  {feature?.text}
                </Paragraph>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default PlatformFeatureBar;

/**
 * Dashed line which is used between the orbs
 * @param props
 */
const Dash: React.FC<{}> = props => {
  return (
    <div className="flex  items-center justify-center border-l border-dashed border-blue-2-light h-16 w-0 lg:border-t lg:h-0 lg:w-44 lg:min-w-44">
      <div className="absolute h-2 w-2 bg-blue-2-light rounded-full" />
    </div>
  );
};
